import { createContext, useContext } from 'react';
import { FIRM_SUMMARY_SPREADSHEET_ALL_FUNDS } from 'pages/Firms/common/constants';
import { FundSelectionContextValue, GrossIRRContextValue, TasksProgressContextValue } from './types';

// One context per request rather than a combined one: the firm summary, tasks progress and
// funds requests resolve at very different times, and a shared value would re-render every
// async cell each time any of them landed.

export const GrossIRRContext = createContext<GrossIRRContextValue>({
  grossIRR: undefined,
  isLoading: false,
});

export const TasksProgressContext = createContext<TasksProgressContextValue>({
  tasksProgress: undefined,
  measurementDateName: undefined,
  isLoading: false,
});

export const FundSelectionContext = createContext<FundSelectionContextValue>({
  fundsAvailable: [FIRM_SUMMARY_SPREADSHEET_ALL_FUNDS],
  selectedFund: FIRM_SUMMARY_SPREADSHEET_ALL_FUNDS,
  setSelectedFund: () => undefined,
});

export const useGrossIRR = () => useContext(GrossIRRContext);

export const useTasksProgress = () => useContext(TasksProgressContext);

export const useFundSelection = () => useContext(FundSelectionContext);
